const e = {
  suffixTextColor: "var(--n-icon-color)"
};
export {
  e as inlineThemeOverrides
};
//# sourceMappingURL=highrise.es358.js.map
